module.exports = __webpack_public_path__ + "img/185.furnichers.5cdcd0de.svg";